import { render, staticRenderFns } from "./RenameTemplateModal.vue?vue&type=template&id=6f572695"
import script from "./RenameTemplateModal.vue?vue&type=script&lang=js"
export * from "./RenameTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports